import { Info } from 'lucide-react';

/**
 * Hinweis, wie Airbnb angebunden wird — anders als Booking.com nicht über eine Kennung aus dem
 * Extranet, sondern über das Mapping-Fenster des Kanalmanagers.
 */
export function AirbnbConnectHint({ onOpenIframe }: { onOpenIframe: () => void }) {
  return (
    <div className="border-line/60 bg-sage/5 text-ink-soft flex flex-wrap items-start gap-3 rounded-md border px-4 py-3 text-xs">
      <Info size={14} className="text-sage mt-0.5 shrink-0" aria-hidden />
      <p className="min-w-0 flex-1">
        <span className="text-ink font-medium">Airbnb verbinden?</span> Airbnb braucht keine Kennung
        aus einem Extranet — die Anmeldung läuft im Mapping-Fenster des Kanalmanagers. Dort Airbnb
        auswählen und den Zugang bestätigen.
      </p>
      <button
        type="button"
        onClick={onOpenIframe}
        className="text-sage inline-flex min-h-11 shrink-0 items-center whitespace-nowrap text-xs font-medium underline-offset-2 hover:underline"
      >
        Mapping öffnen
      </button>
    </div>
  );
}
